import axios from "axios";
// import { api } from "../config";

axios.defaults.baseURL = "http://localhost:3000/api";
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// content type
const authUser: any = localStorage.getItem("authUser");
const authToken = localStorage.getItem("authToken");

// Check if both authUser and authToken exist and are valid
let token = null;
if (authUser && authUser !== 'null' && authUser !== 'undefined' && authUser !== '') {
  try {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser ? parsedUser.token : null;
  } catch (error) {
    console.error("Error parsing authUser:", error);
    token = null;
  }
}

// Also check authToken from localStorage
if (!token && authToken && authToken !== 'null' && authToken !== 'undefined' && authToken !== '') {
  token = authToken;
}

if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

// Request interceptor to check auth token before each request
axios.interceptors.request.use(
  function (config) {
    console.log('=== AXIOS REQUEST INTERCEPTOR ===');
    console.log('Request URL:', config.url);
    console.log('Request Method:', config.method);
    console.log('Request Data:', config.data);
    
    const authToken = localStorage.getItem('authToken');
    
    // Set authorization header if token exists and is valid
    if (authToken && authToken !== '' && authToken !== 'null' && authToken !== 'undefined') {
      config.headers['Authorization'] = `Bearer ${authToken}`;
      console.log('Auth header set:', config.headers['Authorization']);
    } else {
      console.log('No auth token found');
    }
    
    console.log('Final config headers:', config.headers);
    // Don't block requests here, let the component handle auth logic
    return config;
  },
  function (error) {
    console.log('=== REQUEST INTERCEPTOR ERROR ===');
    console.log('Request Error:', error);
    return Promise.reject(error);
  }
);

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    console.log('=== AXIOS RESPONSE INTERCEPTOR ===');
    console.log('Response Status:', response.status);
    console.log('Response Headers:', response.headers);
    console.log('Full Response:', response);
    console.log('Response Data:', response.data);
    
    // Return full response instead of just response.data to preserve original structure
    return response;
  },
  function (error) {
    console.log('=== RESPONSE INTERCEPTOR ERROR ===');
    console.log('Error Status:', error.response?.status);
    console.log('Error Response:', error.response);
    console.log('Full Error:', error);
    
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.response?.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        // Clear auth data and redirect to login on 401
        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');
        window.location.href = '/login';
        break;
      case 403:
        message = "Access forbidden";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    
    // Return the original error to preserve full error information
    return Promise.reject(error);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: any) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url: any, params: any) => {
    let response;

    let paramKeys: any = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url: any, data: any) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url: any, data: any) => {
    return axios.patch(url, data);
  };

  put = (url: any, data: any) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url: any, config: any) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  const authToken = localStorage.getItem("authToken");
  
  // Check if authToken exists and is valid
  if (!authToken || authToken === '' || authToken === 'null' || authToken === 'undefined') {
    return null;
  }
  
  // Check if user exists and is valid
  if (!user || user === '' || user === 'null' || user === 'undefined') {
    return null;
  }
  
  try {
    const parsedUser = JSON.parse(user);
    
    // Since the API response doesn't include token in user object,
    // we just need to validate that user object exists and authToken exists
    if (parsedUser && typeof parsedUser === 'object') {
      return parsedUser;
    }
    
    return null;
  } catch (error) {
    console.error("Error parsing user data:", error);
    return null;
  }
};

export { APIClient, setAuthorization, getLoggedinUser };